import { type UserTextRefusal } from '@services/types';

export const SUPERLIKE_MESSAGE_MAX_LENGTH = 300;

/**
 * The obvious cases only: the server's rules (utilities/textRules.js) decide,
 * and its 422 `reason` is shown the same way.
 */
const LINK_PATTERN =
  /(\b[a-z][a-z0-9+.-]*:\/\/|\bwww\.|\bt\.me\/|telegram\.me\/)/i;
const HANDLE_PATTERN = /(^|[^a-z0-9_.])@[a-z][a-z0-9_]{2,}/i;

export const findSuperlikeMessageRefusal = (
  message: string,
): UserTextRefusal | null => {
  if (LINK_PATTERN.test(message)) return 'link';
  if (HANDLE_PATTERN.test(message)) return 'handle';

  return null;
};

const REFUSAL_TEXT: Record<UserTextRefusal, string> = {
  link: 'Уберите ссылку из сообщения',
  handle: 'Уберите @никнейм из сообщения',
  too_long: 'Сообщение длиннее 300 символов',
  not_text: 'Такое сообщение не отправить, напишите по-другому',
};

const isUserTextRefusal = (value: unknown): value is UserTextRefusal =>
  typeof value === 'string' && value in REFUSAL_TEXT;

/** The inline error under the message for a refusal, the server's or ours. */
export const superlikeMessageErrorText = (reason: unknown) =>
  isUserTextRefusal(reason)
    ? REFUSAL_TEXT[reason]
    : 'Уберите ссылки и @никнеймы из сообщения';
